import React, { useEffect } from 'react';
import Header from'../Component/Header'
import { Link } from 'react-router-dom';
const Admission = () => {  
  
    useEffect(() => {
        document.title = ' Admission - Sacread Heart Kharagpur';  
    }); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>Admission</li>
                  <li>Admission</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Admission</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                         <ul className="list">
                         <li> Applications for admission on the prescribed form will normally be accepted in the month of March.</li>
                         <li> At the time of admission, the parent must submit to the School Office a declaration in writing stating the child's exact date of birth and it must be supported by an authenticated extract from the Registrar of Births (Corporation/Municipality/Gram Panchayat) of extract from the hospital record showing the date of birth with an affidavit shown by the parent/guardian of the child before a magistrate, Catholic children are required to produce their Baptism Certificate at the time of admission.</li>
                         <li> A pupil who has attended any recognized school can be admitted with a Transfer Certificate, From Schools outside West Bengal, the Transfer Certificate must be countersigned by the Inspector of Schools of the State from which the pupil comes. Fees to be paid from April onwards  </li>
                         </ul>
                        
                    </div>
                </div> 
            </div>
        </div> 
     </>
  )
}

export default Admission

